import React, { FC } from 'react';
import { ArrayInput, useTranslate, SimpleFormIterator, SelectInput, required } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { H3 } from '~/components';
import { CurrencySelect } from '~/components/ra';
import { Solution } from '~/types';
import { useFormState } from 'react-final-form';
import { ReferenceInput } from 'react-admin';

interface RefundFormProps {
  keyName: string;
  basePath: string;
  record: Solution;
}

export const RefundForm: FC<RefundFormProps> = ({ keyName, basePath, record }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  const { values } = useFormState();
  return (
    <>
      <H3>{t('refundAccounts')}</H3>
      <ArrayInput source={`${keyName}.accounts`} label='' className={classes.simpleArrayInput}>
        <SimpleFormIterator>
          <CurrencySelect
            label={t('currency')}
            source={`currency`}
            solutionId={record?.id}
            validate={required()}
            record={values}
            className={classes.inputWidth}
          />
          <ReferenceInput
            source={`account`}
            reference='tenant/accounts'
            basePath={basePath}
            label={t('tenantAccount')}
            className={classes.inputWidth}
            perPage={100}
          >
            <SelectInput optionText='alias' />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};
